<template lang="html">
  <div class="exerland">
    <!-- 此处使用keep-alive可以缓存所有的页面 -->
    <keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="$route.meta.keepAlive"/>
    <!-- 用于视频播放的遮罩层 -->
    <van-overlay class="videoBox" :show="show" @click="closeBigScreen">
      <!-- <videoFile :videoUrl="videoUrl" /> -->
      <div ref="video" v-if="show" id="video">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Player from 'xgplayer'
export default {
  components: {
    // videoFile
  },
  data () {
    return {
      isBack: true,
      show: false,
      videoUrl: '',
      player: null
    }
  },
  mounted () {
    this.$bus.$on('openBigScreen', this.openBigScreen)
  },
  // 缓存相关需要做根据路由来做缓存,有些路由不做缓存，尤其关注发表动态页
  // beforeRouteEnter (to, from, next) {
  //   console.log(from.path)
  //   if (from.path !== '/') {
  //     console.log('true')
  //     to.meta.isBack = true
  //   } else {
  //     console.log('false')
  //     to.meta.isBack = false
  //   }
  //   next()
  // }
  methods: {
    // IOS设备设置，防止被浏览器劫持
    isAppleDevice () {
      const ua = navigator.userAgent.toLowerCase()
      return /iphone|ipad|phone|Mac/i.test(ua)
    },
    // 开启大屏
    openBigScreen (url) {
      this.videoUrl = url
      this.show = true
      setTimeout(() => {
        this.player = new Player({
          id: 'video',
          url: this.videoUrl,
          height: '100%',
          width: '100%',
          autoplay: true,
          loop: true,
          playsinline: this.isAppleDevice(),
          'x5-video-player-type': 'h5',
          'x5-video-orientation': 'portraint',
          fullscreen: true // 开启全屏模式
        })
      }, 100)
    },
    // 关闭大屏
    closeBigScreen () {
      this.show = false
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.player.destroy()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exerland {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.videoBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 1);
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
//全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
//播放按钮
video::-webkit-media-controls-play-button {
  display: none;
}
//观看的当前时间
video::-webkit-media-controls-current-time-display{
  display: none;
}
//剩余时间
video::-webkit-media-controls-time-remaining-display {
  display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
  display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
  display: none;
}
</style>
